{
  "actions": "Acțiuni",
  "actionsAvailable": "Acțiuni disponibile.",
  "clearSelection": "Goliți selecția",
  "selected": "{count, plural, =0 {Niciunul selectat} other {# selectate}}",
  "selectedAll": "Toate selectate"
}
